import Divider from 'components/_UI/Divider'
import Icon from 'components/_UI/Icon';
import Text from 'components/_UI/Text';
import { useEventDetailTab } from 'context/dash/EventDetailTab';
import ProductCard from 'modules/dashboard/products/list/ProductCard';
import React from 'react'
import { ShoppingBag, Store } from 'lucide-react';
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';

function fmtCurrency(value) {
    return Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export default function ProductsForSale({ data, detailEvent, offlineStats }) {

    let setEventDetailTab;
    if (!detailEvent) {
        ({ setEventDetailTab } = useEventDetailTab());
    }

    return (
        <Column>
            {/* <Divider marginTop={'40px'} color={colors.primaryDashboard} opacity={0.3} /> */}

            <StyledContent>
                {/* <Column width='20px' height='20px' >
                <Icon name='products' color={colors.nightDark} size='20px' />
            </Column> */}
                <Row>
                    <ShoppingBag width={20} color={colors.secondaryPurple} />
                    <StyledText>
                        <Text name='subtitle' color={colors.nightDark}>Produtos a venda</Text>
                    </StyledText>
                </Row>

            </StyledContent>

            <MainContent>
                {
                    data?.filter((el) => el.type === 'product').map((el) => (
                        <ContentProducts key={el.id} >
                            <ProductCard data={el} onProductClick={() => setEventDetailTab('products')} isVisiblePrice />
                        </ContentProducts>
                    ))

                }
            </MainContent>

            {offlineStats && (
                <OfflineSection>
                    <OfflineLabel>
                        <Store size={12} />
                        Vendas no PDV
                    </OfflineLabel>
                    <OfflineCards>
                        <OfflineCard>
                            <OfflineCardValue>{offlineStats.sold}</OfflineCardValue>
                            <OfflineCardLabel>Produtos vendidos</OfflineCardLabel>
                        </OfflineCard>
                        <OfflineDivider />
                        <OfflineCard>
                            <OfflineCardValue>{fmtCurrency(offlineStats.revenue)}</OfflineCardValue>
                            <OfflineCardLabel>Receita total</OfflineCardLabel>
                        </OfflineCard>
                    </OfflineCards>
                    <OfflineHint>Vendas realizadas pelo caixa presencial vinculado a este evento</OfflineHint>
                </OfflineSection>
            )}
        </Column>
    )
}


const StyledContent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    
    @media screen and (min-width: 690px) {
        display: flex;
        flex-direction: column;
    }
`;

const StyledText = styled(Row)`
    padding: 0;
    height: 20px;
    @media screen and (min-width: 690px){
        padding: 0 10px 0 10px;
    }
`;

const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    @media screen and (min-width: 690px) {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

    }

`;

const ContentProducts = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 20px;
    @media screen and (min-width: ${breakpoints.md}) {
        width: 48%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    & > div {
        width: 100%;
        height: 120px;
        @media screen and (min-width: 690px) {
            width: 95%;
        }

    }
`

/* ── Offline PDV Stats ── */
const OfflineSection = styled.div`
    margin-top: 20px;
    padding: 14px 16px;
    border-radius: 12px;
    background: ${colors.neutralBackground};
    border: 1px solid rgba(0,0,0,0.06);
`;

const OfflineLabel = styled.p`
    display: flex;
    align-items: center;
    gap: 5px;
    margin: 0 0 12px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.7px;
    text-transform: uppercase;
    color: ${colors.nightLight};
`;

const OfflineCards = styled.div`
    display: flex;
    align-items: center;
    gap: 0;
`;

const OfflineCard = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

const OfflineDivider = styled.div`
    width: 1px;
    height: 36px;
    background: rgba(0,0,0,0.1);
    margin: 0 16px;
`;

const OfflineCardValue = styled.p`
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    color: ${colors.nightDark};
    letter-spacing: -0.5px;
`;

const OfflineCardLabel = styled.p`
    margin: 0;
    font-size: 11px;
    color: ${colors.nightLight};
`;

const OfflineHint = styled.p`
    margin: 10px 0 0;
    font-size: 11px;
    color: ${colors.nightLight};
    font-style: italic;
    line-height: 1.4;
`;